export const NEARBY_TRANSFER_STATES = Object.freeze({
  OFFLINE: "offline",
  CONNECTING: "connecting",
  DISCOVERING: "discovering",
  REQUESTING_PAIR: "requestingPair",
  INCOMING_PAIR: "incomingPair",
  PAIRING: "pairing",
  CONNECTED: "connected",
  TRANSFERRING: "transferring",
  FAILED: "failed",
});

export const NEARBY_TRANSFER_ROLES = Object.freeze({
  REQUESTER: "requester",
  RECEIVER: "receiver",
});

export const NEARBY_SOCKET_EVENTS = Object.freeze({
  PRESENCE_JOIN: "presence.join",
  NEARBY_DEVICES: "nearby.devices",
  PAIR_REQUEST: "pair.request",
  PAIR_INCOMING: "pair.incoming",
  PAIR_ACCEPT: "pair.accept",
  PAIR_ACCEPTED: "pair.accepted",
  PAIR_DECLINE: "pair.decline",
  PAIR_DECLINED: "pair.declined",
  WEBRTC_SIGNAL: "webrtc.signal",
  NEARBY_ERROR: "nearby.error",
});

export const WEBRTC_SIGNAL_KINDS = Object.freeze({
  OFFER: "offer",
  ANSWER: "answer",
  ICE_CANDIDATE: "ice-candidate",
});

export const NEARBY_WS_PATH = "/ws/nearby-netpads";
export const NEARBY_RECONNECT_DELAY_MS = 3000;
export const PAIR_REQUEST_TIMEOUT_MS = 60000;
export const NEARBY_TRANSFER_ERROR_MESSAGE =
  "Nearby transfer failed. Check that both devices are online, accepted pairing, and are not blocked by Wi-Fi client isolation.";
